import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api, euro, fmtDate } from "@/lib/api";

export default function Confirm() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [booking, setBooking] = useState(null);
  const sessionId = params.get("session_id");
  const bookingId = params.get("booking");
  const noPay = params.get("waived") || params.get("points");

  useEffect(() => {
    if (noPay && bookingId) {
      api.get(`/bookings/${bookingId}`).then((b) => { setBooking(b.data); setStatus("paid"); }).catch(() => setStatus("failed"));
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          const b = await api.get(`/bookings/${bookingId}`);
          setBooking(b.data);
          return;
        }
        if (data.status === "expired" || attempts >= 6) { setStatus("failed"); return; }
      } catch { if (attempts >= 6) { setStatus("failed"); return; } }
      attempts++;
      setTimeout(poll, 2000);
    };
    if (sessionId) poll(); else setStatus("failed");
  }, [sessionId, bookingId, noPay]);

  if (status === "checking") return (<div className="max-w-xl mx-auto px-6 py-32 text-center"><Loader2 className="animate-spin mx-auto text-burgundy mb-4" /><p className="text-espresso/70">Verifica del pagamento in corso…</p></div>);
  if (status === "failed") return (<div className="max-w-xl mx-auto px-6 py-32 text-center"><h1 className="font-serif text-4xl text-espresso mb-4">Pagamento non completato</h1><Link to="/prenota" className="text-burgundy underline">Torna alla prenotazione</Link></div>);

  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center animate-fade-up">
      <div className="w-16 h-16 rounded-full bg-kimasuccess text-ivory flex items-center justify-center mx-auto mb-6"><Check size={28} /></div>
      <span className="kima-overline text-burgundy">Confermato</span>
      <h1 className="font-serif text-4xl md:text-5xl text-espresso mt-3 mb-8">Il tuo appuntamento è confermato</h1>
      {booking && (
        <div className="border border-espresso/10 bg-offwhite rounded-sm p-8 text-left space-y-3">
          <div className="flex justify-between"><span className="text-espresso/60">Servizio</span><span className="text-espresso">{booking.service_name}</span></div>
          <div className="flex justify-between"><span className="text-espresso/60">Artista</span><span className="text-espresso">{booking.artist_name}</span></div>
          <div className="flex justify-between"><span className="text-espresso/60">Data</span><span className="text-espresso">{fmtDate(booking.date)} · {booking.start_time}</span></div>
          <div className="flex justify-between"><span className="text-espresso/60">Durata</span><span className="text-espresso">{booking.duration_min} min</span></div>
          <div className="flex justify-between border-t border-espresso/10 pt-3"><span className="text-espresso/60">Acconto pagato</span><span className="text-espresso">{euro(booking.amount_paid)}</span></div>
          <div className="flex justify-between"><span className="text-espresso/60">Saldo in salone</span><span className="text-burgundy">{euro(booking.price - booking.amount_paid)}</span></div>
        </div>
      )}
      <Link to="/kima-id" data-testid="confirm-dashboard" className="inline-block mt-8 bg-espresso text-ivory px-8 py-4 rounded-sm hover:bg-burgundy transition-colors">Vai al mio KIMA ID</Link>
    </div>
  );
}
